var type = 0
var Store, store
if (window.isElectron) {
  type = 1
  const { remote } = window.require('electron')
  let path = remote.app.getPath('exe')
  path = path.substring(0, path.lastIndexOf('\\') + 1)
  path += 'user'
  Store = window.require('electron-store')
  store = new Store({cwd: path, watch: true})
}
const localStore = {
  debug: false,
  set (k, v) {
    if (this.debug) {
      console.log('set method call:', k, v)
    }
    if (type === 1) {
      store.set(k, v)
    } else {
      switch (k) {
        case 'clientIp':
          window.store.commit('SET_CLIENTIP', v)
          break
        case 'userlist':
          window.store.commit('SET_USERLIST', v)
          break
        case 'remUser':
          window.store.commit('SET_REMUSER', v)
          break
        case 'proUser':
          window.store.commit('SET_PROUSER', v)
          break
        case 'token':
          window.store.commit('SET_TOKEN', v)
          break
        case 'ucWsCurrUser':
          window.store.commit('SET_UCWSCURRUSER', v)
          break
        case 'out':
          window.store.commit('SET_OUT', v)
          break
        case 'reload':
          window.store.commit('SET_RELOAD', v)
          break
        case 'limit':
          window.store.commit('SET_LIMIT', v)
          break
        default:
          break
      }
    }
  },
  get (k) {
    if (this.debug) {
      console.log('get method call:', k)
    }
    if (type === 1) {
      return store.get(k)
    } else {
      switch (k) {
        case 'clientIp':
          return window.store.getters.clientIp
        case 'userlist':
          return window.store.getters.userlist
        case 'remUser':
          return window.store.getters.remUser
        case 'proUser':
          return window.store.getters.proUser
        case 'token':
          return window.store.getters.token
        case 'ucWsCurrUser':
          return window.store.getters.ucWsCurrUser
        case 'out':
          return window.store.getters.out
        case 'reload':
          return window.store.getters.reload
        case 'limit':
          return window.store.getters.limit
        default:
          break
      }
    }
  },
  has (k) {
    if (this.debug) {
      console.log('has method call:', k)
    }
    return store.has(k)
  },
  remove (k) {
    if (this.debug) {
      console.log('remove method call:', k)
    }
    if (type === 1) {
      store.delete(k)
    } else {
      switch (k) {
        case 'clientIp':
          window.store.commit('REMOVE_CLIENTIP')
          break
        case 'userlist':
          window.store.commit('REMOVE_USERLIST')
          break
        case 'remUser':
          window.store.commit('REMOVE_REMUSER')
          break
        case 'proUser':
          window.store.commit('REMOVE_PROUSER')
          break
        case 'token':
          window.store.commit('REMOVE_TOKEN')
          break
        case 'ucWsCurrUser':
          window.store.commit('REMOVE_UCWSCURRUSER')
          break
        case 'out':
          window.store.commit('REMOVE_OUT')
          break
        case 'reload':
          window.store.commit('REMOVE_RELOAD')
          break
        case 'limit':
          window.store.commit('REMOVE_LIMIT')
          break
        default:
          break
      }
    }
  },
  clear () {
    if (this.debug) {
      console.log('clear method call')
    }
    store.clear()
  },
  onChange (k, callback) {
    if (this.debug) {
      console.log('onChange method call:', k)
    }
    store.onDidChange(k, callback)
  }
}

export default localStore
